export default __webpack_public_path__ + "static/media/add.6f785130.svg";